import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import mutations from './mutations'
import state from './state'
Vue.use(Vuex) //注册插件
export default new Vuex.Store({
    getters,
    state,
    mutations,
})
//注册后去main.js 注册


// WEBPACK FOOTER //
// ./src/store/index.js